import axios from 'axios';
import _ from 'lodash';
import { CommonHeaderProps, CommonProps, CommonQueryProps } from '../../types/commons';

// config
export const request = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_BASEURL,
});

export const querystring = (query:CommonQueryProps) => {
  return {
    params: query
  };
};

export const removeNullInObject = (obj:CommonProps) => {
  return _.pickBy(obj, function (value, key) {
      return !_.isEmpty(value) || _.isNumber(value);
  });
}
  
export const headers = (header:CommonHeaderProps) => {
  return {
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
      ...header && header,
    }
  };
};
  
export const refreshHeaders = (refreshToken:string|number, header?:CommonHeaderProps) => {
  return {
    headers: {
      'Authorization': `Bearer ${refreshToken}`,
      ...header && header,
    }
  };
};